<template>
  <div v-if="visible" class="gx-import-dialog" @click.self="handleClose">
    <section class="gx-import-dialog__box" role="dialog" aria-modal="true" aria-label="新增商品">
      <header class="gx-import-dialog__head">
        <div class="gx-import-dialog__title-wrap">
          <span class="gx-import-dialog__title">新增商品</span>
          <template v-if="view !== 'menu'">
            <span class="gx-import-dialog__divider">/</span>
            <span class="gx-import-dialog__mode" :style="modeStyle(currentMode)">
              <span class="gx-import-dialog__mode-icon">{{ currentMode.icon }}</span>
              {{ currentMode.name }}
            </span>
          </template>
        </div>
        <div class="gx-import-dialog__head-actions">
          <button v-if="view !== 'menu'" type="button" class="gx-import-dialog__back" @click="view = ['agreement', 'confirm'].includes(view) ? 'link' : 'menu'">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M6 2 2 5l4 3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /></svg>
            返回
          </button>
          <button type="button" class="gx-import-dialog__close" aria-label="关闭" :disabled="uploading || submitting"
                  @click="handleClose">
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none" aria-hidden="true"><path d="m1 1 9 9m0-9-9 9" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" /></svg>
          </button>
        </div>
      </header>

      <main v-if="view === 'menu'" class="gx-import-dialog__body gx-import-dialog__menu">
        <button
            v-for="(item, index) in importModes"
            :key="item.key"
            type="button"
            class="gx-import-dialog__mode-card"
            :class="[{ 'gx-import-dialog__mode-card--disabled': !item.enabled }, `gx-import-dialog__mode-card--${item.key}`]"
            :style="modeStyle(item)"
            @click="selectMode(item)"
        >
          <span class="gx-import-dialog__number">{{ String(index + 1).padStart(2, '0') }}</span>
          <span class="gx-import-dialog__icon">{{ item.icon }}</span>
          <span class="gx-import-dialog__mode-copy">
            <span class="gx-import-dialog__mode-name">{{ item.name }} <small v-if="item.badge">{{ item.badge }}</small></span>
            <span class="gx-import-dialog__mode-desc">{{ item.desc }}</span>
          </span>
          <span class="gx-import-dialog__arrow">›</span>
        </button>
      </main>

      <main v-else-if="view === 'agreement'" class="gx-import-dialog__body">
        <h3>商品链接导入授权承诺书</h3>
        <p class="gx-import-dialog__agreement-copy">{{ agreement.body }}</p>
        <p class="gx-import-dialog__agreement-promise">{{ agreement.signature_text }}</p>
        <template v-if="agreement.signed && !requiresResign">
          <p class="gx-import-dialog__agreement-signed">该承诺书已签署。</p>
        </template>
        <template v-else>
          <label class="gx-import-dialog__label" for="cloud-import-promise">请输入上方蓝色承诺内容完成签署</label>
          <textarea id="cloud-import-promise" v-model="typedPromise" class="gx-import-dialog__textarea gx-import-dialog__textarea--promise" rows="3" :disabled="!isHost" />
          <p v-if="!isHost" class="gx-import-dialog__error">请由商家主账号签署后再使用链接导入。</p>
        </template>
      </main>

      <main v-else-if="view === 'link'" class="gx-import-dialog__body">
        <div class="gx-import-dialog__supported-platforms" aria-label="支持平台：1688">
          <span class="gx-import-dialog__supported-platforms-title">支持平台：</span>
          <img class="gx-import-dialog__platform-icon" :src="platform1688Icon" alt="1688" title="1688">
<!--          <img class="gx-import-dialog__platform-icon" :src="douyinIcon" alt="抖音" title="抖音">-->
        </div>
        <p class="gx-import-dialog__platform-tip">导入商品链接需先安装观星树运营插件。</p>
        <label class="gx-import-dialog__label" for="cloud-import-links">商品链接（每行一个）</label>
        <textarea id="cloud-import-links" v-model="linkText" class="gx-import-dialog__textarea" rows="5"
                  :placeholder="'https://detail.1688.com/offer/123456.html'"/>
        <div class="gx-import-dialog__count">已识别 {{ parsedLinks.validLinks.length }} 条商品链接；每行一个，单次最多 10,000 条<span
            v-if="parsedLinks.invalidLines.length">，{{ parsedLinks.invalidLines.length }} 条格式无效</span></div>
        <div v-if="parsedLinks.invalidLines.length" class="gx-import-dialog__error">无效行：{{ parsedLinks.invalidLines.slice(0, 5).join('、') }}{{ parsedLinks.invalidLines.length > 5 ? '…' : '' }}</div>
        <div class="gx-import-dialog__form-grid gx-import-dialog__form-grid--link">
          <label class="gx-import-dialog__group">
            <span class="gx-import-dialog__label">加入子分组</span>
            <select v-model="linkChildGroupId" class="gx-import-dialog__select">
              <option value="">不加入分组</option>
              <option v-for="group in childGroups" :key="group.id" :value="group.id">{{ group.displayName }}</option>
            </select>
          </label>
        </div>
        <div class="gx-import-dialog__agreement-status">
          <input class="gx-import-dialog__agreement-check" type="checkbox" :checked="agreementChecked" @change="handleAgreementCheck">
          <span>{{ agreementChecked ? '已签署' : '未签署' }}</span>
          <button type="button" @click="openAgreement">商品链接导入授权承诺书</button>
          <span>，请遵守平台相关规范，使用者请获取授权后再进行商品铺货。</span>
        </div>
      </main>

      <main v-else-if="view === 'confirm'" class="gx-import-dialog__body">
        <h3>确认链接导入</h3>
        <div class="gx-import-dialog__confirm-summary">
          <strong>共识别 {{ parsedLinks.validLinks.length }} 条商品链接</strong>
        </div>
        <p v-if="parsedLinks.invalidLines.length" class="gx-import-dialog__error">{{ parsedLinks.invalidLines.length }} 条无效链接不会提交：第 {{ parsedLinks.invalidLines.slice(0, 5).join('、') }} 行{{ parsedLinks.invalidLines.length > 5 ? '…' : '' }}</p>
      </main>

      <main v-else class="gx-import-dialog__body">
        <div class="gx-import-dialog__notice gx-import-dialog__notice--blue">
          <i aria-hidden="true"></i>
          <span>支持TB、PDD、DY、WX，如有不支持解析包提供给客服；仅支持 ZIP 格式，单文件不超过 100 MB。</span>
        </div>
        <span class="gx-import-dialog__label">数据包类型</span>
        <div class="gx-import-dialog__package-types gx-import-dialog__package-types--single">
          <span class="gx-import-dialog__package-type gx-import-dialog__package-type--on"><b>🤝</b>合作商品包</span>
        </div>
        <input ref="packageInput" class="gx-import-dialog__file-input" type="file"
               accept=".zip,application/zip,application/x-zip-compressed" @change="handleFileChange"/>
        <div class="gx-import-dialog__drop-zone"
             :class="{ 'gx-import-dialog__drop-zone--busy': uploading, 'gx-import-dialog__drop-zone--ready': packageUpload.url }"
             @dragover.prevent @drop.prevent="handleDrop" @click="chooseFile">
          <template v-if="uploading">
            <strong>正在安全校验并上传… {{ packageUpload.progress }}%</strong>
            <span class="gx-import-dialog__progress"><i :style="{ width: `${packageUpload.progress}%` }"></i></span>
          </template>
          <template v-else-if="packageUpload.url">
            <strong>✓ {{ packageUpload.fileName }}</strong>
            <small>已安全校验并上传至 OSS</small>
          </template>
          <template v-else>
            <span class="gx-import-dialog__folder">📁</span>
            <strong>点击上传或将 ZIP 文件拖到此处</strong>
            <small>仅支持 .zip 格式，文件大小不超过 100 MB</small>
          </template>
        </div>
        <div v-if="packageUpload.error" class="gx-import-dialog__error">{{ packageUpload.error }}</div>
        <label class="gx-import-dialog__group">
          <span class="gx-import-dialog__label">加入子分组</span>
          <select v-model="packageChildGroupId" class="gx-import-dialog__select">
            <option value="">不加入分组</option>
            <option v-for="group in childGroups" :key="group.id" :value="group.id">{{ group.displayName }}</option>
          </select>
        </label>
      </main>

      <footer class="gx-import-dialog__foot">
        <span>{{
            view === 'menu' ? '选择一种导入方式继续' : `当前方式：${['link', 'agreement', 'confirm'].includes(view) ? '链接导入' : '数据包导入'}`
          }}</span>
        <div v-if="view !== 'menu'" class="gx-import-dialog__foot-actions">
          <button type="button" class="gx-import-dialog__button" :disabled="uploading || submitting || signing" @click="view = ['agreement', 'confirm'].includes(view) ? 'link' : 'menu'">返回
          </button>
          <button type="button" class="gx-import-dialog__button gx-import-dialog__button--primary" :disabled="checkingPlugin || uploading || submitting || signing || (view === 'agreement' && !isHost && !(agreement.signed && !requiresResign)) || (view === 'link' && !agreementChecked)"
                  @click="view === 'agreement' ? (agreement.signed && !requiresResign ? view = 'link' : signPromise()) : confirmCurrent()">{{ view === 'agreement' ? (agreement.signed && !requiresResign ? '我知道了' : '签署并继续') : view === 'link' ? '下一步' : (checkingPlugin ? '检测中…' : '确定导入') }}
          </button>
        </div>
        <button v-else type="button" class="gx-import-dialog__button" @click="handleClose">取消</button>
      </footer>
    </section>
  </div>
</template>

<script>
import JSZip from 'jszip'
import {uploadDirectOss} from '@/assets/js/utils/ossDirectUpload'

const MAX_FILE_SIZE = 100 * 1024 * 1024
const MAX_ZIP_ENTRIES = 10000
const MAX_UNCOMPRESSED_SIZE = 500 * 1024 * 1024
const MAX_ENTRY_UNCOMPRESSED_SIZE = 5 * 1024 * 1024
const MAX_COMPRESSION_RATIO = 100
const ALIBABA_ICON = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAAXNSR0IArs4c6QAAAJNQTFRFAAAA74Ag74AY74Ag74Ag73wc73wa73wd73ob730b73sZ73sb730b73wc73wb730b730d8X0b730c73sa73wb73wc73wb730b73wb730c73wb8IQp8Yw48pRG8pVG85xU851U9KRi9KVi9a1x9rV/9rZ/972N976N+MWb+c2p+c6p+ta4+97G/ObU/e/j/vfx/////VtikgAAABp0Uk5TABAgIDBAUFBgYHBwcICQn5+fr7C/v8/f7+/x5LAFAAADGElEQVRYw+2YX3fbKBDFabPeZrfJdtsmTXsZS6pQEUUI7vf/dPsg/5FcIdmxn/Z0njg256fhDjMDKDXYmz8fHl9j9xs1tr+e8Gp7+XC3x9xdgQGAr3/vOC+41gbSJ1xvG6XUuxtw8HQjh4A7pb7dBPRe/XETDj6qzdoUvTXWhxBC55ptdtazul+klC4kjix6mZ/4ZQlU+iPkOLLz+zsLEjt2JYqu91h7CagMnFoUAHVHkqzOBp1iUnBGD35GkuFMkEwwvTNjfSWSPA800ia6Wp/+3ZCUM0BFv6eEZjbSDUm9DmrSnqIz0QxkXF+aG2TJUoCSpF8D6d2ywsJWj/MSTUBykCfvkM04NAZJnGw+AND2BFmTTLIM0v0vHEg/XaVEkj9Wcs3N+JPqMHZJx9zCRiB72IWuFEDKJqRWoxqDuom786DigPH9rvBUekZoChZB+iC0AaBFMgHLCHQEHQSiyc00JNliGSRcBRWJZIcV0LFu5EqyRJJxdqOWVvagg0MhJ6WOmYBp66qjR/vQZ5VEN1thdRliNV5aWNF5+FJ7SnEpmKlGQ+xdliPkSRHSxieG6lTsAZTvon7irxgXySlmsrSZJrOLUhoyZ/vdWN8nkkyumAu/PUn6AfLd2eK4srHN1eEXdX9MkK4ptyJSmsZ1KbkDeNr922JhZ8fFj/44/txWK0nbxvGJw5wWxi7E4Jtar6UIAFSN895bU+jXnbZXzke/Qb9B/zfQLlO0XAXSTUgAtI0MAJrI5AWAjezdJaBAcqgusQYMGRN7wDHFTHHPgIwngcih2wRaCCmIrFAzXaKRkKiZnDUCOPZbS2oEuq1jfynI70u5Trs2IolkKi4FBabWRAZYMpK93g3c5SAPGEZNtpDEpiQrmEtuRwPoJx3QsC9IATp6wwggzfb2ZbHpXWKrE6N1pKlIb7t5j54z7wdCAi2HU2wdd4OW2WPbc+a6ro0BIPVwV9OVGQZSGzPfZT7f7gFBPd0E9FatvyCcY1+Uuo1LG6WUenv9Q9Tj8KR1Nenx8Fj3cA3qefLwt3n459/X2OO7NwPgP3xRO1+o0+FaAAAAAElFTkSuQmCC'
const DOUYIN_ICON = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAAXNSR0IArs4c6QAAAVxQTFRFAAAAEBAQEBAQFBQUEBAQExMTEBAQEBAQEhISEhISEhISERERERERERERERERERERERERAPX/AefwAtnhBLzDBa60BbzDBp+lBp+mB5GWB5GXB5+lB5+mCJGXCYOICnV5C2dqC2drDFhbDUpNDjw+Dy4vEB8gEPb/ERERFL3DHy4vIBQUIPb/LxcXLyMjMPb/PhoaQPf/QtvhTR0dUPn/XCAgYPn/aiMjayMjcPn/eSYmeT09eiYmf/r/gPr/iCkpj/r/j/v/lywsn/v/oO3woPv/ot/hpS8vpi8vr/z/v/z/v/3/wOPkwq6uwzQ0wzU1z/3/0jc30jg432Nk3+bn3/3/3/7/4To64VJS4aam4eHh70tM74eI7/Lz7/7/8D09/0BA/0xM/1hY/2Rk/3Bw/3x8/4iI/5OT/5SU/5+f/6Cg/6ur/6ys/7e3/8PD/8/P/9vb/+fn//Pz////XA3gpgAAABF0Uk5TACBAQGBgb3Bwj5CvsL/P3+/IrksXAAAC8UlEQVRYw+3Ya3vSMBQA4AKbcyCXrgydzuFkZVGognXKpoiCus3pmDfwCmHWTVSu/f/PY1N6G0tL2uaj5xslfQlJc3IahplEaDESTwC3EY8uhhhrXHBvmNi8wQRiwFfEA5oTB4CK5NsBIIaceUAhLpJ0KLNuxIZdmwTDBGf+2iprxJptoxATdgOt2jYKM1ESqFybxPNKRcA3ukQwZwp0IGshwS2bJ4ABrqAh3LEbbXeQ/OfQppVbSO6KlCD5DU8JksuXM1kqkFxmWY4KJDfylCBZfr0jFqhAIwj3/kNYaEwJGh33RnQgCL+e9L9Tgd42IXwvfftJDGXXV5a55HloD5QUCgURlEmqKZrDQQCIlXqbCOKTWq7ngJDDQChy6JsZUHpJVTa39z+oN2IhgkV7VWWKB8aNHqEram+eWW70Bq0hJ/9R9gvdQM7dluwXynJWxwe0ZvlfviDUoZrOjHunXiE0Qg905kRfCB6gZQXSJ+wY+oCWzA5JSGlXS4IXaIM1bukjp5rDL9qZUEaZMq1DaIAquHxEBCljfV+DfkDYBH6gJxqkdEj0Be1rUAe2gXfoprnvSLCOgYaEEG9CXQuUMi4PyJ8j/a+NO00Lb3koyKAU+0JfaD2o5WQerb+jycVT85lwhtLstrHy+4/UvJJGTt583MmgLFu0lGW3Vq4lJ/tAzZg0u3p9Oo2kNlum9FR/AylrF34rUIEM4s1BUuKoiPaBoj6TKCE0AWHOvl48Uwa1Gg3zwy/oMGnTUJZ7JduEmhAEUgjw92ycUcexQ+c3SP4l1hmijNkUXEDg9heM8xf1x37K8EXEnc/TzEBNvPChUznGYA4zhE96qaguO41pi451HfZVVDiEUrc/GI4Gva7UmWwndcH5MIKJYK/r9Z0e77ZmFJpR29f1Ut1Q2rvizIo17HCAkBMfV3arlVKB5ExDOUbycXRkHSKGWaABzaHjmhidDlE8iPItxQLGKducDyqxcObcLxiOuscS8Ug4qAH/AOqQIoyOsFJ6AAAAAElFTkSuQmCC'

export default {
  name: 'ProductImportDialog',
  props: {
    visible: {type: Boolean, default: false},
    groups: {type: Array, default: () => []},
    submitting: {type: Boolean, default: false}
  },
  data() {
    return {
      platform1688Icon: ALIBABA_ICON,
      douyinIcon: DOUYIN_ICON,
      view: 'menu',
      linkText: '',
      linkRequestId: '',
      linkChildGroupId: '',
      packageChildGroupId: '',
      uploading: false,
      signing: false,
      checkingPlugin: false,
      agreement: {},
      agreementChecked: false,
      requiresResign: false,
      typedPromise: '',
      packageUpload: {fileName: '', url: '', progress: 0, error: ''},
      importModes: [
        {
          key: 'publish',
          icon: '✍️',
          name: '发布商品',
          badge: '手动创建',
          desc: '手动填写商品标题、主图、SKU 等信息',
          accent: '#52C41A',
          background: 'rgba(82, 196, 26, .07)',
          border: 'rgba(82, 196, 26, .25)',
          enabled: false
        },
        {
          key: 'link',
          icon: '🔗',
          name: '链接导入',
          badge: '1688 + DY',
          desc: '混合粘贴商品链接，自动识别来源并导入',
          accent: '#D4A946',
          background: 'rgba(212, 169, 70, .07)',
          border: 'rgba(212, 169, 70, .28)',
          enabled: true
        },
        {
          key: 'package',
          icon: '📁',
          name: '数据包导入',
          badge: '合作商品包',
          desc: '上传合作商品数据包并自动识别导入',
          accent: '#3FB6E0',
          background: 'rgba(63, 182, 224, .07)',
          border: 'rgba(63, 182, 224, .28)',
          enabled: true
        },
        {
          key: 'template',
          icon: '📋',
          name: '数据包格式导入',
          badge: '参考模板格式',
          desc: '下载标准模板，按格式填写后上传',
          accent: '#8B5CF6',
          background: 'rgba(139, 92, 246, .07)',
          border: 'rgba(139, 92, 246, .28)',
          enabled: false
        },
        {
          key: 'shop',
          icon: '🔄',
          name: '店铺同步商品导入',
          badge: '已授权店铺',
          desc: '从已授权店铺同步商品到云商品库',
          accent: '#3FB6E0',
          background: 'rgba(63, 182, 224, .07)',
          border: 'rgba(63, 182, 224, .28)',
          enabled: false
        }
      ],
    }
  },
  computed: {
    currentMode() {
      return this.importModes.find(item => item.key === (['agreement', 'confirm'].includes(this.view) ? 'link' : this.view)) || {}
    },
    isHost() {
      const value = this.$store.state.login.is_host
      return value === true || value === 1 || value === '1' || value === 'true'
    },
    childGroups() {
      return this.groups.reduce((items, parent) => {
        if (parent.is_shared) return items
        const children = Array.isArray(parent.child_groups) ? parent.child_groups : []
        children.forEach(child => {
          if (child.is_shared) return
          items.push({
            ...child,
            displayName: `${parent.name || '未命名分组'} / ${child.name || '未命名子分组'}`
          })
        })
        return items
      }, [])
    },
    validChildGroupIds() {
      return new Set(this.childGroups.map(group => String(group.id)))
    },
    parsedLinks() {
      const validLinks = []
      const seen = new Set()
      const invalidLines = []
      this.linkText.split(/[\r\n]+/).forEach((raw, index) => {
        const link = raw.trim()
        if (!link) return
        const productId = this.get1688ProductId(link)
        if (productId) {
          const key = `1688:${productId}`
          if (!seen.has(key)) { seen.add(key); validLinks.push({type: '1688', url: link}) }
        } else {
          const douyin = this.getDouyinUrl(link)
          if (!douyin) return invalidLines.push(index + 1)
          const key = `douyin:${douyin}`
          if (!seen.has(key)) { seen.add(key); validLinks.push({type: 'douyin', url: douyin}) }
        }
      })
      return { validLinks, invalidLines }
    }
  },
  watch: {
    visible(value) {
      if (value) this.reset()
    },
    linkText() { this.linkRequestId = '' },
    linkChildGroupId() { this.linkRequestId = '' }
  },
  methods: {
    modeStyle(item) {
      return {
        '--gx-accent': item.accent || '#D4A946',
        '--gx-mode-background': item.background || 'rgba(212, 169, 70, .07)',
        '--gx-mode-border': item.border || 'rgba(212, 169, 70, .28)'
      }
    },
    reset() {
      this.view = 'menu'
      this.linkText = ''
      this.linkRequestId = ''
      this.linkChildGroupId = ''
      this.packageChildGroupId = ''
      this.uploading = false
      this.signing = false
      this.checkingPlugin = false
      this.agreementChecked = false
      this.requiresResign = false
      this.typedPromise = ''
      this.packageUpload = {fileName: '', url: '', progress: 0, error: ''}
      this.$nextTick(() => {
        if (this.$refs.packageInput) this.$refs.packageInput.value = ''
      })
    },
    async handleClose() {
      if (this.uploading || this.submitting || this.signing || this.checkingPlugin) return
      if (this.linkText.trim() && ['link', 'confirm'].includes(this.view)) {
        try { await this.$confirm('当前输入的链接尚未提交，确定关闭吗？', '提示', {type: 'warning'}) }
        catch (e) { return }
      }
      this.$emit('update:visible', false)
    },
    async selectMode(item) {
      if (!item.enabled) {
        this.$message.info('功能开发中')
        return
      }
      if (item.key !== 'link') { this.view = item.key; return }
      try {
        const res = await this.$store.dispatch('linkImport/getAgreement')
        if (res.code !== 200) throw new Error(res.message || '承诺书加载失败')
        this.agreement = res.data || {}
        this.agreementChecked = Boolean(this.agreement.signed)
        this.requiresResign = false
        this.view = 'link'
      } catch (error) {
        this.$message.error(error.message || '承诺书加载失败')
      }
    },
    async signPromise() {
      if (this.typedPromise.trim() !== this.agreement.signature_text) return this.$message.error('请输入完整承诺内容')
      this.signing = true
      try {
        const res = await this.$store.dispatch('linkImport/signAgreement', {version: this.agreement.version, typed_text: this.typedPromise})
        if (res.code !== 200) throw new Error(res.message || '签署失败')
        this.agreement = res.data
        this.agreementChecked = true
        this.requiresResign = false
        this.view = 'link'
      } catch (error) {
        this.$message.error(error.message || '签署失败')
      } finally { this.signing = false }
    },
    openAgreement() {
      this.typedPromise = ''
      this.view = 'agreement'
    },
    handleAgreementCheck(event) {
      if (!event.target.checked) {
        this.agreementChecked = false
        this.requiresResign = true
        return
      }
      event.target.checked = false
      this.openAgreement()
    },
    getDouyinUrl(link) {
      try {
        const url = new URL(link)
        if (url.protocol !== 'https:') return ''
        const host = url.hostname.toLowerCase()
        if (host === 'v.douyin.com' && /^\/[a-z0-9_-]+\/?$/i.test(url.pathname)) {
          return `https://v.douyin.com/${url.pathname.split('/').filter(Boolean)[0]}/`
        }
        // 抖音商品直链，商品ID在查询参数id中，如 https://haohuo.jinritemai.com/ecommerce/trade/detail/index.html?id=3832959427204481058&origin_type=604
        if (host === 'haohuo.jinritemai.com' && url.pathname.toLowerCase() === '/ecommerce/trade/detail/index.html') {
          const id = url.searchParams.get('id') || ''
          if (/^\d{6,25}$/.test(id)) return `https://haohuo.jinritemai.com/ecommerce/trade/detail/index.html?id=${id}`
        }
        return ''
      } catch (e) { return '' }
    },
    get1688ProductId(link) {
      try {
        const url = new URL(link)
        if (url.protocol !== 'https:' || url.hostname.toLowerCase() !== 'detail.1688.com') return ''
        const match = url.pathname.match(/^\/offer\/(\d+)\.html$/i)
        return match ? match[1] : ''
      } catch (e) {
        return ''
      }
    },
    ensureValidChildGroup(field) {
      const childGroupId = this[field]
      if (childGroupId === '' || childGroupId === null || childGroupId === undefined) return true
      if (this.validChildGroupIds.has(String(childGroupId))) return true
      this[field] = ''
      this.$message.warning('所选子分组不可用，请重新选择')
      return false
    },
    async confirmCurrent() {
      if (this.view === 'link') {
        const {validLinks} = this.parsedLinks
        if (!validLinks.length) return this.$message.error('请输入有效的商品链接')
        if (validLinks.length > 10000) return this.$message.error('单次最多导入 10,000 条商品链接')
        if (!this.ensureValidChildGroup('linkChildGroupId')) return
        this.view = 'confirm'
        return
      }
      if (this.view === 'confirm') {
        if (!this.agreementChecked) return this.$message.error('请先签署承诺书')
        const alibabaIds = this.parsedLinks.validLinks.filter(item => item.type === '1688').map(item => this.get1688ProductId(item.url))
        let douyinLinks = this.parsedLinks.validLinks.filter(item => item.type === 'douyin').map(item => item.url)
        if (douyinLinks.length) {
          // 只有插件明确报告未安装（false）才跳过探测；变量未注入（undefined）时探测一次，避免已装插件被误判为未安装
          let pluginState = {responded: false, online: false, loggedIn: false}
          if (window.__isGxsExtensionInstalled__ !== false) {
            this.checkingPlugin = true
            try {
              pluginState = await this.probeExtensionOnline()
            } finally {
              this.checkingPlugin = false
            }
            if (!this.visible || this.view !== 'confirm') return
          }
          if (!pluginState.responded) {
            if (!alibabaIds.length) {
              try {
                await this.$confirm('检测到 DY 商品链接，请先安装观星树运营插件并确认已允许其访问本站后再创建链接任务。', '需要安装插件', {
                  confirmButtonText: '去安装', cancelButtonText: '取消', type: 'warning'
                })
                this.$router.push({path: '/new_system_workbench', query: {menu: 'software'}})
              } catch (error) { /* retain the entered links */ }
              return
            }
            try {
              await this.$confirm(`未检测到观星树运营插件，DY ${douyinLinks.length} 条链接不会导入。是否继续导入 1688 ${alibabaIds.length} 条商品？`, 'DY 链接暂不导入', {
                confirmButtonText: '继续导入 1688', cancelButtonText: '取消', type: 'warning'
              })
              douyinLinks = []
            } catch (error) { return }
          } else if (!pluginState.online) {
            this.$message.error('观星树运营插件当前不在线，请确认插件已开启后刷新页面。')
            return
          } else if (!pluginState.loggedIn) {
            try {
              await this.$confirm('请先在浏览器中登录抖音后再使用DY链接任务', '抖音未登录', {
                confirmButtonText: '去登录', cancelButtonText: '取消', type: 'warning'
              })
              window.open('https://www.douyin.com/', '_blank')
            } catch (error) { /* retain the entered links */ }
            return
          }
        }
        if (!this.linkRequestId) {
          this.linkRequestId = (window.crypto && window.crypto.randomUUID)
            ? window.crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`
        }
        this.$emit('import-link', {
          requestId: this.linkRequestId,
          alibabaIds,
          douyinLinks,
          childGroupId: this.linkChildGroupId
        })
        return
      }
      if (!this.packageUpload.url) return this.$message.error('请先完成数据包上传')
      if (!this.ensureValidChildGroup('packageChildGroupId')) return
      this.$emit('import-package', {
        ossUrl: this.packageUpload.url,
        fileName: this.packageUpload.fileName,
        childGroupId: this.packageChildGroupId
      })
    },
    /**
     * 探测观星树运营插件是否在线、抖音是否已登录。
     * responded 表示插件是否有应答；超时或未响应时为 false，据此区分“没装/没响应”与“插件明确不在线”。
     */
    probeExtensionOnline() {
      return new Promise(resolve => {
        let timer = null
        const finish = state => {
          window.clearTimeout(timer)
          window.removeEventListener('message', listener)
          resolve(state)
        }
        const listener = event => {
          if (event.source !== window || !event.data || !['xingjieliu_content', 'xingjieliu_check_online_result'].includes(event.data.source) || event.data.type !== 'ONLINE_RESULT') return
          const result = event.data.data || {}
          const online = result.data || result
          const isOnline = result.success !== false && online.online === true
          finish({responded: true, online: isOnline, loggedIn: isOnline && online.loggedIn === true})
        }
        window.addEventListener('message', listener)
        timer = window.setTimeout(() => finish({responded: false, online: false, loggedIn: false}), 3000)
        window.postMessage({source: 'demo_page', type: 'xingjieliu_check_online'}, '*')
      })
    },
    chooseFile() {
      if (!this.uploading && this.$refs.packageInput) this.$refs.packageInput.click()
    },
    handleDrop(event) {
      if (!this.uploading) this.uploadPackage((event.dataTransfer.files || [])[0])
    },
    handleFileChange(event) {
      this.uploadPackage((event.target.files || [])[0])
    },
    async uploadPackage(file) {
      if (!file || this.uploading) return
      this.packageUpload = {fileName: '', url: '', progress: 0, error: ''}
      try {
        await this.validateZipPackage(file)
        this.uploading = true
        this.packageUpload.fileName = file.name
        const result = await uploadDirectOss(file, {
          purpose: 'cloud_import_package',
          timeout: 180000,
          onProgress: ({percent}) => {
            this.packageUpload.progress = percent
          }
        })
        this.packageUpload.url = result.url || result.address || ''
        if (!this.packageUpload.url) throw new Error('OSS 未返回文件链接')
        this.packageUpload.progress = 100
        this.$message.success('数据包已安全校验并上传至 OSS')
      } catch (error) {
        this.packageUpload.error = error && error.message ? error.message : '数据包上传失败，请重试'
      } finally {
        this.uploading = false
        if (this.$refs.packageInput) this.$refs.packageInput.value = ''
      }
    },
    async validateZipPackage(file) {
      const name = String(file.name || '')
      if (!/\.zip$/i.test(name)) throw new Error('仅支持 ZIP 数据包')
      if (!file.size) throw new Error('不允许上传空数据包')
      if (file.size > MAX_FILE_SIZE) throw new Error('数据包不能超过 100 MB')
      const signature = new Uint8Array(await this.readAsArrayBuffer(file.slice(0, 4)))
      const isZip = signature[0] === 0x50 && signature[1] === 0x4b && ((signature[2] === 0x03 && signature[3] === 0x04) || (signature[2] === 0x05 && signature[3] === 0x06) || (signature[2] === 0x07 && signature[3] === 0x08))
      if (!isZip) throw new Error('文件内容不是有效的 ZIP 数据包')

      let archive
      try {
        archive = await JSZip.loadAsync(file, {createFolders: false})
      } catch (error) {
        throw new Error('ZIP 数据包损坏、加密或无法读取')
      }
      const state = {entryCount: 0, fileCount: 0, uncompressedSize: 0}
      this.validateArchiveEntries(archive, state)
      if (!state.fileCount) throw new Error('ZIP 数据包中未找到可导入文件')
    },
    validateArchiveEntries(archive, state) {
      const entries = Object.values(archive.files || {})
      if (!entries.length) throw new Error('不允许上传空 ZIP 数据包')

      state.entryCount += entries.length
      if (state.entryCount > MAX_ZIP_ENTRIES) throw new Error(`ZIP 文件数量不能超过 ${MAX_ZIP_ENTRIES} 个`)

      const files = []
      for (const entry of entries) {
        const unsafeName = String(entry.unsafeOriginalName || entry.name || '')
        if (!unsafeName || unsafeName.length > 255 || unsafeName.includes('\\') || unsafeName.startsWith('/') || unsafeName.split('/').includes('..')) {
          throw new Error('ZIP 包含不安全的文件路径')
        }
        if (entry.dir) continue
        this.validateArchiveEntrySize(entry, state)
        files.push({entry, name: unsafeName})
      }
      if (!files.length) throw new Error('ZIP 数据包中未找到可导入文件')

      for (const {name} of files) {
        if (/\.(txt|json)$/i.test(name)) {
          state.fileCount += 1
          continue
        }
        if (/\.zip$/i.test(name)) continue
        throw new Error('ZIP 内仅允许 .txt/.json 文件；内层 ZIP 将被跳过')
      }
    },
    validateArchiveEntrySize(entry, state) {
      const data = entry._data || {}
      const entrySize = Number(data.uncompressedSize)
      const compressedSize = Number(data.compressedSize)
      if (!Number.isFinite(entrySize) || entrySize < 0 || entrySize > MAX_ENTRY_UNCOMPRESSED_SIZE) throw new Error('ZIP 包含异常大小的文件')
      if (compressedSize > 0 && entrySize / compressedSize > MAX_COMPRESSION_RATIO) throw new Error('ZIP 压缩比异常，可能存在解压风险')
      state.uncompressedSize += entrySize
      if (state.uncompressedSize > MAX_UNCOMPRESSED_SIZE) throw new Error('ZIP 解压后的总大小不能超过 500 MB')
    },
    readAsArrayBuffer(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = event => resolve(event.target.result)
        reader.onerror = () => reject(new Error('读取数据包失败'))
        reader.readAsArrayBuffer(blob)
      })
    }
  }
}
</script>

<style scoped>
.gx-import-dialog {
  position: fixed;
  inset: 0;
  z-index: 760;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, .48);
  backdrop-filter: blur(6px);
}

.gx-import-dialog__box {
  width: min(640px, 100%);
  overflow: hidden;
  border: 1px solid #e1e5ee;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 20px 56px rgba(15, 23, 42, .22);
}

.gx-import-dialog__head, .gx-import-dialog__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  background: #f5f0e8;
}

.gx-import-dialog__head {
  border-bottom: 1px solid #e1e5ee;
}

.gx-import-dialog__title-wrap, .gx-import-dialog__head-actions, .gx-import-dialog__foot-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.gx-import-dialog__title {
  position: relative;
  padding-left: 10px;
  color: #1a1a2e;
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 700;
}

.gx-import-dialog__title::before {
  position: absolute;
  top: 50%;
  left: 0;
  width: 3px;
  height: 15px;
  border-radius: 2px;
  background: #c8443c;
  content: '';
  transform: translateY(-50%);
}

.gx-import-dialog__divider {
  color: #c7cad3;
}

.gx-import-dialog__mode {
  color: #1f9dcc;
  font-size: 13px;
  font-weight: 600;
}

.gx-import-dialog__close, .gx-import-dialog__back, .gx-import-dialog__button {
  border: 1px solid #dfe3ed;
  border-radius: 6px;
  background: #fff;
  color: #4a4a6a;
  cursor: pointer;
}

.gx-import-dialog__close {
  width: 26px;
  height: 26px;
  font-size: 22px;
  line-height: 20px;
}

.gx-import-dialog__back {
  height: 26px;
  padding: 0 9px;
}

.gx-import-dialog__close:disabled {
  cursor: not-allowed;
  opacity: .55;
}

.gx-import-dialog__body {
  max-height: calc(90vh - 112px);
  overflow-y: auto;
  padding: 18px;
}

.gx-import-dialog__menu {
  display: grid;
  gap: 9px;
}

.gx-import-dialog__mode-card {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 66px;
  gap: 13px;
  padding: 10px 14px;
  border: 1px solid #dce1ec;
  border-radius: 10px;
  background: #fff;
  text-align: left;
  cursor: pointer;
  transition: border-color .16s, box-shadow .16s;
}

.gx-import-dialog__mode-card:not(.gx-import-dialog__mode-card--disabled):hover {
  border-color: #7dd3fc;
  box-shadow: 0 3px 12px rgba(56, 189, 248, .12);
}

.gx-import-dialog__mode-card--disabled {
  cursor: not-allowed;
  opacity: .48;
}

.gx-import-dialog__number {
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  border: 1px solid #cde2f7;
  border-radius: 7px;
  background: #f0f9ff;
  color: #269bd1;
  font-size: 11px;
}

.gx-import-dialog__mode-card--link .gx-import-dialog__number {
  border-color: #f1d6a0;
  background: #fffaf0;
  color: #d99a19;
}

.gx-import-dialog__mode-card--publish .gx-import-dialog__number {
  border-color: #c8efc6;
  background: #f4fff2;
  color: #55ad4d;
}

.gx-import-dialog__icon {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border: 1px solid #e1e5ee;
  border-radius: 8px;
  background: #f8fafc;
  font-size: 18px;
}

.gx-import-dialog__mode-copy {
  display: grid;
  gap: 5px;
  flex: 1;
}

.gx-import-dialog__mode-name {
  color: #25263d;
  font-size: 14px;
  font-weight: 700;
}

.gx-import-dialog__mode-name small {
  padding: 1px 7px;
  border-radius: 4px;
  background: #ecf9ff;
  color: rgb(82, 196, 26);
  font-size: 10px;
  font-weight: 500;
  border: 1px solid rgba(82, 196, 26, 0.25);
  font-family: "Noto Sans SC", sans-serif;
}

.gx-import-dialog__mode-desc {
  color: #9295a1;
  font-size: 11px;
}

.gx-import-dialog__arrow {
  color: #b9bdc8;
  font-size: 24px;
}

.gx-import-dialog__notice {
  margin-bottom: 16px;
  padding: 10px 12px;
  border: 1px solid;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.5;
}

.gx-import-dialog__notice--amber {
  border-color: #f0d6a3;
  background: #fffaf0;
  color: #8b6b2a;
}

.gx-import-dialog__notice--blue {
  border-color: #b8e2f7;
  background: #f0faff;
  color: #537182;
}

.gx-import-dialog__label {
  display: block;
  margin-bottom: 7px;
  color: #5d6072;
  font-size: 12px;
}

.gx-import-dialog__textarea, .gx-import-dialog__select {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #dce1ec;
  border-radius: 7px;
  background: #fff;
  color: #303246;
  font: inherit;
  font-size: 12px;
  outline: none;
}

.gx-import-dialog__textarea {
  padding: 10px;
  resize: vertical;
}

.gx-import-dialog__textarea:focus, .gx-import-dialog__select:focus {
  border-color: #4bc1ee;
}

.gx-import-dialog__count {
  margin: 8px 0 14px;
  color: #8a8e9c;
  font-size: 11px;
}

.gx-import-dialog__group {
  display: block;
}

.gx-import-dialog__select {
  height: 34px;
  padding: 0 10px;
}

.gx-import-dialog__package-types {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 9px;
  margin-bottom: 14px;
}

.gx-import-dialog__package-type {
  display: grid;
  gap: 5px;
  min-height: 62px;
  place-content: center;
  border: 1px solid #dce1ec;
  border-radius: 8px;
  background: #f8f5ef;
  color: #4a4a62;
  cursor: pointer;
  font-size: 12px;
}

.gx-import-dialog__package-type--on {
  border-color: #3dbceb;
  background: #effaff;
  color: #20a5d6;
  font-weight: 700;
}

.gx-import-dialog__file-input {
  display: none;
}

.gx-import-dialog__drop-zone {
  display: grid;
  min-height: 130px;
  place-content: center;
  gap: 8px;
  padding: 14px;
  border: 2px dashed #dce2ef;
  border-radius: 9px;
  background: #fcfdff;
  color: #3b3d50;
  text-align: center;
  cursor: pointer;
}

.gx-import-dialog__drop-zone:hover {
  border-color: #8bd7f3;
}

.gx-import-dialog__drop-zone--busy {
  cursor: wait;
}

.gx-import-dialog__drop-zone--ready {
  border-color: #88d8a3;
  background: #f4fff6;
}

.gx-import-dialog__folder {
  font-size: 25px;
}

.gx-import-dialog__drop-zone small {
  color: #a2a5b0;
  font-size: 11px;
}

.gx-import-dialog__progress {
  display: block;
  width: 260px;
  max-width: 100%;
  height: 6px;
  overflow: hidden;
  border-radius: 9px;
  background: #e7ebf2;
}

.gx-import-dialog__progress i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #3dbceb;
  transition: width .15s;
}

.gx-import-dialog__error {
  margin: 8px 0 12px;
  color: #dd564e;
  font-size: 12px;
  line-height: 1.5;
}

.gx-import-dialog__foot {
  min-height: 52px;
  border-top: 1px solid #e1e5ee;
  color: #9295a1;
  font-size: 12px;
}

.gx-import-dialog__button {
  height: 32px;
  padding: 0 13px;
}

.gx-import-dialog__button--primary {
  border-color: #ff6e6e;
  background: #ff6e6e;
  color: #fff;
}

.gx-import-dialog__agreement-copy,
.gx-import-dialog__agreement-promise {
  line-height: 1.7;
  font-size: 13px;
}

.gx-import-dialog__agreement-promise { color: #1769d1; font-weight: 600; }
.gx-import-dialog__agreement-signed { color: #52a344; font-size: 13px; }
.gx-import-dialog__confirm-summary {
  display: grid;
  gap: 12px;
  margin-top: 18px;
  padding: 18px;
  border: 1px solid #dfe5f2;
  border-radius: 8px;
  background: #f8faff;
  color: #25263d;
  font-size: 14px;
}
.gx-import-dialog__agreement-status {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #e1e5ee;
  color: #3e4556;
  font-size: 13px;
  line-height: 1.5;
}
.gx-import-dialog__agreement-check {
  display: inline-grid;
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  margin: 0;
  appearance: none;
  border: 1px solid #d9deea;
  border-radius: 3px;
  background: #fff;
  cursor: pointer;
}
.gx-import-dialog__agreement-check:checked {
  border-color: #1677ff;
  background: #1677ff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cpath d='m2 6 2.5 2.5L10 3' fill='none' stroke='%23fff' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center/12px no-repeat;
}
.gx-import-dialog__agreement-status button {
  padding: 0;
  border: 0;
  background: transparent;
  color: #1677ff;
  cursor: pointer;
  font: inherit;
}
.gx-import-dialog__textarea--promise { height: 92px; min-height: 92px; }
.gx-import-dialog__form-grid--link > * { grid-column: 1 / -1; }

.gx-import-dialog__button:disabled {
  cursor: not-allowed;
  opacity: .55;
}

@media (max-width: 600px) {
  .gx-import-dialog {
    align-items: flex-start;
    padding: 12px;
  }

  .gx-import-dialog__box {
    margin-top: 8px;
  }

  .gx-import-dialog__body {
    padding: 14px;
  }

  .gx-import-dialog__mode-desc {
    display: none;
  }

  .gx-import-dialog__package-types {
    grid-template-columns: 1fr;
  }

  .gx-import-dialog__foot {
    align-items: flex-start;
    gap: 10px;
    flex-direction: column;
  }

  .gx-import-dialog__foot-actions {
    width: 100%;
    justify-content: flex-end;
  }
}

/* 设计稿的颜色与尺寸仅作用于本导入弹窗，避免影响旧版 Element UI 弹窗。 */
.gx-import-dialog__box {
  display: flex;
  max-height: 90vh;
  border: 1.5px solid #e0e0ec;
  border-radius: 12px;
  box-shadow: 0 24px 72px rgba(0, 0, 0, .24);
  flex-direction: column;
}

.gx-import-dialog__head, .gx-import-dialog__foot {
  flex-shrink: 0;
  padding: 12px 18px;
  background: #f5f0e8;
}

.gx-import-dialog__head {
  border-bottom-color: #e0e0ec;
}

.gx-import-dialog__title-wrap, .gx-import-dialog__head-actions, .gx-import-dialog__foot-actions {
  gap: 8px;
}

.gx-import-dialog__title {
  color: #1a1a2e;
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 600;
}

.gx-import-dialog__mode {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  border: 1px solid var(--gx-mode-border);
  border-radius: 5px;
  background: var(--gx-mode-background);
  color: var(--gx-accent);
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 12px;
  font-weight: 600;
}

.gx-import-dialog__mode-icon {
  font-size: 12px;
}

.gx-import-dialog__close, .gx-import-dialog__back, .gx-import-dialog__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 1.5px solid #e0e0ec;
  border-radius: 5px;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 12px;
}

.gx-import-dialog__close {
  font-size: 0;
}

.gx-import-dialog__close svg {
  color: #666;
}

.gx-import-dialog__body {
  flex: 1;
  padding: 18px;
}

.gx-import-dialog__menu {
  gap: 8px;
}

.gx-import-dialog__mode-card {
  position: relative;
  min-height: 0;
  gap: 14px;
  overflow: hidden;
  padding: 13px 16px;
  border: 1.5px solid #e0e0ec;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .04);
}

.gx-import-dialog__mode-card::before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 3px;
  border-radius: 10px 0 0 10px;
  background: var(--gx-accent);
  content: '';
  opacity: 0;
  transition: opacity .16s;
}

.gx-import-dialog__mode-card:not(.gx-import-dialog__mode-card--disabled):hover {
  border-color: var(--gx-accent);
  background: var(--gx-mode-background);
  box-shadow: 0 2px 7px rgba(0, 0, 0, .07);
}

.gx-import-dialog__mode-card:not(.gx-import-dialog__mode-card--disabled):hover::before {
  opacity: 1;
}

.gx-import-dialog__mode-card--disabled {
  opacity: .5;
}

.gx-import-dialog__mode-card .gx-import-dialog__number, .gx-import-dialog__icon {
  border: 1.5px solid var(--gx-mode-border);
  background: var(--gx-mode-background);
  color: var(--gx-accent);
}

.gx-import-dialog__number {
  border-radius: 7px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 700;
}

.gx-import-dialog__icon {
  width: 36px;
  height: 36px;
  border-radius: 9px;
}

.gx-import-dialog__mode-copy {
  gap: 2px;
}

.gx-import-dialog__mode-name {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #1a1a2e;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  font-weight: 600;
}

.gx-import-dialog__mode-name small {
  padding: 1px 7px;
  border: 1px solid var(--gx-mode-border);
  border-radius: 4px;
  background: var(--gx-mode-background);
  color: var(--gx-accent);
  font-size: 10px;
  font-weight: 500;
}

.gx-import-dialog__mode-desc {
  color: #999;
  font-family: 'Noto Sans SC', sans-serif;
  line-height: 1.55;
}

.gx-import-dialog__arrow {
  color: #1a1a2e;
  font-size: 0;
  opacity: .3;
}

.gx-import-dialog__arrow::after {
  content: '›';
  font-size: 24px;
}

.gx-import-dialog__notice {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  padding: 9px 12px;
  border-radius: 8px;
  color: #666;
  font-family: 'Noto Sans SC', sans-serif;
}

.gx-import-dialog__notice i {
  width: 3px;
  height: 24px;
  border-radius: 2px;
  background: currentColor;
  flex-shrink: 0;
}

.gx-import-dialog__notice--amber {
  border-color: rgba(212, 169, 70, .35);
  background: rgba(212, 169, 70, .07);
  color: #d4a946;
}

.gx-import-dialog__notice--amber span, .gx-import-dialog__notice--blue span {
  color: #666;
}

.gx-import-dialog__notice--blue {
  border-color: rgba(63, 182, 224, .28);
  background: rgba(63, 182, 224, .07);
  color: #3fb6e0;
}

.gx-import-dialog__supported-platforms {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 14px;
}

.gx-import-dialog__supported-platforms-title {
  color: #666;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 12px;
  font-weight: 600;
}

.gx-import-dialog__platform-icon {
  display: block;
  width: 30px;
  height: 30px;
  border-radius: 7px;
  object-fit: cover;
}

.gx-import-dialog__platform-tip {
  margin: -6px 0 14px;
  color: #b6892d;
  font-size: 12px;
}

.gx-import-dialog__label {
  color: #666;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 11px;
  letter-spacing: .02em;
}

.gx-import-dialog__textarea, .gx-import-dialog__select {
  border: 1.5px solid #e0e0ec;
  border-radius: 5px;
  color: #1a1a2e;
  font-family: 'Noto Sans SC', sans-serif;
}

.gx-import-dialog__textarea {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  line-height: 1.75;
}

.gx-import-dialog__textarea:focus, .gx-import-dialog__select:focus {
  border-color: #d4a946;
}

.gx-import-dialog__count {
  margin: 3px 0 14px;
  color: #999;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 10px;
}

.gx-import-dialog__form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.gx-import-dialog__source-card {
  box-sizing: border-box;
  display: grid;
  height: 34px;
  place-items: center;
  border: 1.5px solid #d4a946;
  border-radius: 6px;
  background: rgba(212, 169, 70, .07);
  color: #d4a946;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 11px;
  font-weight: 700;
}

.gx-import-dialog__select {
  height: 34px;
}

.gx-import-dialog__package-types {
  margin-bottom: 14px;
}

.gx-import-dialog__package-types--single {
  display: block;
}

.gx-import-dialog__package-type.gx-import-dialog__package-type--on {
  display: flex;
  min-height: 0;
  height: 56px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1.5px solid #3fb6e0;
  border-radius: 8px;
  background: rgba(63, 182, 224, .08);
  color: #3fb6e0;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 11px;
  font-weight: 600;
}

.gx-import-dialog__package-type b {
  font-size: 18px;
  font-weight: 400;
}

.gx-import-dialog__drop-zone {
  min-height: 0;
  padding: 24px 0;
  border-color: #e0e0ec;
  border-radius: 8px;
  background: #fafafa;
  font-family: 'Noto Sans SC', sans-serif;
}

.gx-import-dialog__drop-zone:hover {
  border-color: #3fb6e0;
  background: rgba(0, 0, 0, .015);
}

.gx-import-dialog__drop-zone--ready {
  border-color: #52c41a;
  background: rgba(82, 196, 26, .05);
}

.gx-import-dialog__drop-zone small {
  color: #999;
}

.gx-import-dialog__foot {
  min-height: 54px;
  border-top-color: #e0e0ec;
  color: #999;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 11px;
}

.gx-import-dialog__button {
  height: 32px;
  padding: 0 16px;
  color: #666;
  font-size: 13px;
}

.gx-import-dialog__button--primary {
  border: 0;
  background: linear-gradient(135deg, #ff4d4f, #ff7875);
  color: #fff;
  font-weight: 600;
}

@media (max-width: 600px) {
  .gx-import-dialog__form-grid {
    grid-template-columns: 1fr;
  }
}
</style>
